import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import state from './state';
import './styles/index.css';
import './utils/i18n/index';

const context = {
  state,
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <App context={context} />
);
